import type { SplitResult } from './harmonyParser';
import { splitHarmonyStreaming } from './harmonyParser';
import { splitGemmaStreaming } from './gemmaParser';

const GEMMA_MODEL_RE = /\bgemma\b/i;
const GPT_OSS_MODEL_RE = /gpt-oss/i;
const THINKING_TAG_RE = /<\/?think(?:ing)?>/i;
const GEMMA_THINKING_MODEL_RE = /\bthinking\b/i;

const STRUCTURED_MARKERS = [
    '<|channel|>',
    '<|channel>',
    '<channel|>',
    '<|turn>',
    '<turn|>',
    '<|think|>',
];

export function isGPTOssModel(model?: string): boolean {
    return GPT_OSS_MODEL_RE.test(model || '');
}

export function isGemmaModel(model?: string): boolean {
    return GEMMA_MODEL_RE.test(model || '');
}

export function isGemmaThinkingModel(model?: string): boolean {
    return isGemmaModel(model) && GEMMA_THINKING_MODEL_RE.test(model || '');
}

export function hasStructuredAssistantTags(raw: string): boolean {
    if (!raw) return false;
    if (THINKING_TAG_RE.test(raw)) return true;
    return STRUCTURED_MARKERS.some((marker) => raw.includes(marker));
}

export function splitAssistantResponse(
    raw: string,
    model?: string,
): SplitResult {
    if (!raw) return { analysis: '', final: '' };

    if (isGPTOssModel(model) || raw.includes('<|channel|>')) {
        return splitHarmonyStreaming(raw);
    }

    if (isGemmaModel(model) || hasStructuredAssistantTags(raw)) {
        const parsed = splitGemmaStreaming(raw);

        if (isGemmaModel(model) && !isGemmaThinkingModel(model)) {
            return {
                analysis: '',
                final: parsed.final || parsed.analysis,
            };
        }

        return parsed;
    }

    return splitHarmonyStreaming(raw);
}
